module.exports = "<div class=\"track master-track\">\n  <md-toolbar class=\"track-toolbar\">\n    <div class=\"md-toolbar-tools\">\n      <span class=\"track-key system-text bold\" ng-click=\"vm.onEdit({track: vm.track})\">\n        Master\n      </span>\n      <span flex class=\"flex\"></span>\n    </div>\n  </md-toolbar>\n  <md-content class=\"track-content\" flex>\n    <textarea ui-codemirror=\"{ onLoad : vm.codemirrorLoaded }\" ui-codemirror-opts=\"{{vm.options}}\" ng-model=\"vm.part\">\n    </textarea>\n  </md-content>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/web/track/master-track.html
// module id = 189
// module chunks = 0